module.exports = __webpack_public_path__ + "static/media/HelveticaNeue.ccad04d4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/HelveticaNeue.ttf
// module id = 972
// module chunks = 0 1 2 3 4 5 6 7